import { skillDefById } from '../data/guide/skills'
import type { Item, WorldData } from '../types/world'

/** Prefijos y sufijos con los que items.csv nombra a los ítems que enseñan un poder. */
const SKILL_PREFIX = /^(scroll|orb|parchment|book|pergamino|orbe|libro)\s+(of|de(l)?)\s+/i
const SKILL_SUFFIX = /\s+(parchment|scroll|book)$/i

/** Secciones de items.csv con orbes (12) y pergaminos (15) de habilidad. */
const LEARN_SECTIONS = new Set([12, 15])
const SCROLL_SECTIONS = new Set([15])

/**
 * Nombre del PODER que enseña un ítem (no el del objeto), o undefined si no es un ítem de habilidad.
 * 1) Por skill_id, cuando el registro central lo conoce ("Drain Life Parchment" → Drain Life).
 * 2) Por el nombre del ítem, quitando "Scroll of…", "Orb of…" o "…Parchment".
 */
export function skillNameOf(item: Item): string | undefined {
  const byPrefix = SKILL_PREFIX.test(item.name)
  const inLearnSection = item.section !== undefined && LEARN_SECTIONS.has(item.section)
  if (inLearnSection || byPrefix) {
    const def = skillDefById(item.skillId)
    if (def) return def.name
  }
  const m = SKILL_PREFIX.exec(item.name)
  if (m) return item.name.slice(m[0].length).trim()
  if (item.section !== undefined && SCROLL_SECTIONS.has(item.section)) return item.name.replace(SKILL_SUFFIX, '').trim()
  return undefined
}

export function skillKindOf(item: Item): string {
  const p = /^(\w+)/.exec(item.name)?.[1]?.toLowerCase()
  if (p === 'orb' || p === 'orbe') return 'Orbe de habilidad'
  if (p === 'book' || p === 'libro') return 'Libro de habilidad'
  if (p === 'parchment' || /parchment$/i.test(item.name)) return 'Pergamino de habilidad'
  return 'Pergamino de habilidad'
}

export function isSkillItem(w: WorldData, id: string): boolean {
  const it = w.items.get(w.variants.get(id)?.itemId ?? id)
  return !!it && skillNameOf(it) !== undefined
}

export const isLearnSection = (section: number | undefined) => section !== undefined && LEARN_SECTIONS.has(section)
